import { Fragment, useEffect, useState } from "react";
import Product from "../components/Product";

export default function Home(){
    const [products, setProducts]= useState([]);
    useEffect(()=>{
      fetch(process.env.REACT_APP_API_URL+'action=read&table=products')
      .then(res=>res.json())
      .then(res=>setProducts(res.data))
    },[])
    return <Fragment>
    <h1 id="products_heading">ORS Nasco Products</h1>
    <section id="products" className="container mt-5">
      <div className="row">
        {products.map(product=><Product product={product}/>)}
      </div>
    </section>
    </Fragment>
}